import Accessory               from './model-accessory';
import Accessories             from './collection-accessories';
import AccessoryCollectionView from './view-accessory-collection-view';
import AccessoryView           from './view-accessory-view';

import Module from 'scripts/module';

const AccessoriesModule = new Module('AccessoriesModule',{
	collections: {
		Accessories,
	},
	models     : {
		Accessory,
	},
	views      : {
		AccessoryCollectionView,
		AccessoryView,
	}
});
export default AccessoriesModule;